import { render, staticRenderFns } from "./WindowImpacts.vue?vue&type=template&id=491d4270&scoped=true"
import script from "./WindowImpacts.vue?vue&type=script&lang=ts"
export * from "./WindowImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491d4270",
  null
  
)

export default component.exports